import {Log} from '../../shared/log';

const log = Log.getLogger('AuthTokenService');

import {tokenNotExpired} from 'angular2-jwt';
import {Injectable} from '@angular/core';

declare const $: any;

/**
 * Update to call keycloak
 */
@Injectable()
export class AuthTokenService {
  private tokenKey = 'access_token';
  private expiry = 'expires_in';
  private returnPathKey = 'return_path';

  private savedAuthToken;

  constructor() {
  }

  public monitorForTokenChange() {
    const self = this;
    self.checkTokenChanged();

    $(window).focus(function () {
      self.checkTokenChanged();
    });
  }

  private checkTokenChanged() {
    const token = this.getToken()
      if (this.savedAuthToken && token !== this.savedAuthToken) {
        log.debug('New token retrived successfully');
      }
      this.savedAuthToken = token;
  }

  public setReturnPath(returnPath: string) {
    if (returnPath) {
      localStorage.setItem(this.returnPathKey, returnPath);
    }
  }

  public getToken(): string {
      return localStorage.getItem(this.tokenKey);
  }

  public clear(): void {
    localStorage.clear();
  }

  public checkTokenNotExpired(token?): boolean {
    let notExpired = false;
    try {
      notExpired = tokenNotExpired(this.tokenKey, token);
      return notExpired;
    } catch (error) {
      log.error('Error checking token expiry');
      this.clear();
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./app/services/auth/auth-token.service.ts